import { IBranchCreate, IBranchDetails, IBranchListSearch, IEditBranchPayload, IGetBranchList } from "../../../types/master/branchInterface";
import {
  BranchActionTypes,
  BranchActions,
} from "../../actionTypes/master/branchActionTypes";

export const createBranch = (payload: IBranchCreate): BranchActionTypes => ({
  type: BranchActions.CREATE_BRANCH,
  payload,
});

export const getBranchList = (payload: IBranchListSearch): BranchActionTypes => ({
  type: BranchActions.GET_BRANCH_LIST,
  payload,
});

export const setBranchList = (branchList: Array<IGetBranchList>) : BranchActionTypes => ({
  type: BranchActions.SET_BRANCH_LIST,
  payload: branchList
})

export const setBranchListPageCount = (payload:number): BranchActionTypes => ({
  type: BranchActions.SET_BRANCH_LIST_PAGE_COUNT,
  payload
})

export const getBranchDataById = (id: number | string): BranchActionTypes => ({
  type: BranchActions.GET_BRANCH_DATA_BY_ID,
  payload: id
})

export const setBranchDataById = (payload: IBranchDetails) => ({
  type: BranchActions.SET_BRANCH_DATA_BY_ID,
  payload
})

export const editBranch = (payload: IEditBranchPayload) => ({
  type: BranchActions.EDIT_BRANCH_DATA_BY_ID,
  payload,
});
